var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22469_7117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5938 6.03125C15.8438 6.03125 16.0312 6.25 15.9688 6.46875L15.7812 7.21875C15.75 7.40625 15.5938 7.53125 15.4375 7.53125H15.0625C15.3125 7.96875 15.5 8.46875 15.5 9V13.25C15.5 13.6875 15.1562 14 14.75 14H14.25C13.8125 14 13.5 13.6875 13.5 13.25V12.5H2.5V13.25C2.5 13.6875 2.15625 14 1.75 14H1.25C0.8125 14 0.5 13.6875 0.5 13.25V9C0.5 8.46875 0.65625 7.96875 0.90625 7.5H0.5625C0.375 7.5 0.21875 7.375 0.1875 7.21875L0 6.46875C-0.0625 6.25 0.125 6 0.375 6H2L2.96875 3.59375C3.34375 2.625 4.28125 2 5.28125 2H10.6875C11.6875 2 12.625 2.625 13 3.59375L13.9688 6.03125H15.5938ZM4.375 4.15625L3.59375 6H12.375L11.5938 4.15625C11.4688 3.75 11.0938 3.5 10.6875 3.5H5.28125C4.875 3.5 4.53125 3.75 4.375 4.15625ZM14 10.5V9C14 8.1875 13.3125 7.5 12.5 7.5H3.5C2.65625 7.5 2 8.1875 2 9V10.5C2 10.7812 2.21875 11 2.5 11H13.5C13.75 11 14 10.7812 14 10.5ZM4 8.25C4.59375 8.25 5.5 9.15625 5.5 9.75C5.5 10.3438 4.59375 10.25 4 10.25C3.375 10.25 3 9.875 3 9.25C3 8.65625 3.375 8.25 4 8.25ZM12 8.25C12.5938 8.25 13 8.65625 13 9.25C13 9.875 12.5938 10.25 12 10.25C11.375 10.25 10.5 10.3438 10.5 9.75C10.5 9.15625 11.375 8.25 12 8.25Z",
    fill: "#394045"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22469_7117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.5c129ff4.svg";
export { ForwardRef as ReactComponent };